export const toMin = (hm) => {
  if (!hm) return null;
  const [h, m] = hm.split(":").map(Number);
  return h * 60 + m;
};

export const toHm = (m) => {
  const v = ((Math.round(m) % 1440) + 1440) % 1440;
  return `${String(Math.floor(v / 60)).padStart(2, "0")}:${String(v % 60).padStart(2, "0")}`;
};

export const fmtDuration = (min) => (min >= 60 ? `${Math.floor(min / 60)} h ${min % 60} min` : `${min} min`);

export const KIND = {
  riconsegna: { label: "Riconsegna", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  ritiro: { label: "Ritiro", cls: "bg-sky-50 text-[#0D3B52] border-sky-200" },
  extra: { label: "Tappa extra", cls: "bg-stone-100 text-stone-700 border-stone-200" },
};

// Current delay (minutes) based on the last stop marked as arrived.
export const currentDelay = (stops) => {
  const done = stops.filter((s) => s.arrived_at);
  if (!done.length) return 0;
  const last = done[done.length - 1];
  return toMin(last.arrived_at) - toMin(last.eta);
};

export const gmapsLinks = (route) => {
  const pts = [route.depot, ...route.stops.filter((s) => !s.arrived_at), ...(route.roundtrip ? [route.depot] : [])]
    .map((p) => `${p.lat},${p.lon}`);
  const links = [];
  for (let i = 0; i < pts.length - 1; i += 9) {
    const seg = pts.slice(i, i + 10);
    const wp = seg.length > 2 ? `&waypoints=${encodeURIComponent(seg.slice(1, -1).join("|"))}` : "";
    links.push(`https://www.google.com/maps/dir/?api=1&origin=${seg[0]}&destination=${seg[seg.length - 1]}&travelmode=driving${wp}`);
  }
  return links;
};

export const navLink = (s) => `https://www.google.com/maps/dir/?api=1&destination=${s.lat},${s.lon}&travelmode=driving`;
